<template>
  <section class="legal-intro position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>
    
    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="legal-intro-content text-center">
            <div class="legal-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="legal-main-title">
              <h2>{{ content.mainTitle }}</h2>
            </div>
            <div class="legal-description">
              <p>{{ content.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PolicyIntroComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Legal Information",
        mainTitle: "Policy Title",
        description: "Policy description goes here."
      })
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.pattern-1 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-3 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-4 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Legal Intro Section */
.legal-intro {
  background: #00061a;
  position: relative;
  overflow: hidden;
}

.legal-intro-content {
  position: relative;
  z-index: 2;
}

.legal-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
  text-transform: uppercase;
}

.legal-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.legal-description p {
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  font-family: "Open Sans", sans-serif;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .see__pad {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .see__pad {
    padding: 60px 0;
  }

  .legal-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .pattern-1,
  .pattern-2,
  .pattern-3,
  .pattern-4 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .see__pad {
    padding: 40px 0;
  }

  .legal-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .legal-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }

  .legal-description p {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
